module.exports = __webpack_public_path__ + "static/media/availableRedemption.65260e8a.svg";